import styles from "@shared/components/chat/Messages.module.scss"

import React, { memo } from "react"

import { ChatDownIcon, PowerfulMessage } from "@shared/components"
import { useLayerPopupContext, useMessagesContext } from "@shared/contexts"
import { useMessagesRef } from "@shared/hooks"

import classNames from "classnames"

interface Props {
  isActive: boolean
}

function ManagerMessages({ isActive }: Props) {
  const { font } = useLayerPopupContext()

  const { managerMessages: messages } = useMessagesContext()
  const { messagesRef } = useMessagesRef({ messages })

  return (
    <div
      className={classNames(
        "chatB",
        [isActive ? styles.active : styles.hidden],
        styles.activePadding,
        styles.inactivePadding,
      )}
    >
      <div className={classNames("inner", styles[font.size])} ref={messagesRef}>
        {messages.map((message) => (
          <PowerfulMessage key={message.key} message={message} />
        ))}
        <ChatDownIcon messagesRef={messagesRef} />
      </div>
    </div>
  )
}

export default memo(ManagerMessages)
